import { Holding } from '@/hooks/portfolio/usePortfolio';

type Props = {
  holding: Holding;
};

export const getPortfolioNarrativeFairValue = ({ holding }: Props) => ({
  fairValue: holding.company.myValuation?.fairValue ?? null,
  valuationId: holding.company.myValuation?.id ?? null,
  narrativeId: holding.company.myValuation?.narrative?.id,
  type: holding.company.myValuation?.type ?? null,
  author: holding.company.myValuation?.narrative?.author ?? null,
});
